<template>
  <section class="container error__container">
    <a-warning
      class="error__block_robot"
      :status-code="error.statusCode"
      :title="ERROR_TITLE.PAGE_NOT_FOUND"
    />

    <div class="error__logo-details__wrap">
      <a-error-logo class="error__block_logo" />

      <a-details
        class="error__block_details"
        :message="ERROR_MESSAGE.PAGE_NOT_FOUND"
      />
    </div>
  </section>
</template>
<script>
import { mapActions } from 'vuex'

import { ROUTE } from 'enums/routes'
import { ERROR_MESSAGE, ERROR_TITLE } from 'enums/errorCodes'

export default {
  props: ['error'],
  layout: 'error-layout',
  components: {
    AWarning: () => import('@/components/_layout/Error/AWarning'),
    AErrorLogo: () => import('@/components/_layout/Error/ALogo'),
    ADetails: () => import('@/components/_layout/Error/ADetails')
  },
  head() {
    const pageName = `Page Not Found`

    return this.$generateMetaTags({
      titleParam: pageName,
      descriptionParam: pageName,
      source: 'seo/errorPageSeo'
    })
  },
  data() {
    return {
      ROUTE,
      ERROR_TITLE,
      ERROR_MESSAGE
    }
  },
  methods: {
    ...mapActions({
      requestFormsSettings: 'leads/requestFormsSettings',
      requestAuthStatus: 'auth/requestAuthStatus'
    })
  },
  mounted() {
    this.requestFormsSettings()
    this.requestAuthStatus()
  }
}
</script>

<style lang="scss" scoped>
$desktop-sm-width: 1024px;

.error__container {
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 40px 0 60px 0;
  margin-bottom: 20px;

  @include tablet {
    padding: 0 15px;
    padding: 32px 0 48px 0;
  }

  @include mobile {
    flex-direction: column;
    align-items: center;
    margin-bottom: 0;
    padding: 24px 0 32px 0;
    margin-bottom: 4px;
  }

  .error__logo-details__wrap {
    display: flex;
    flex-direction: column;
    max-width: 600px;
    width: 100%;

    @include mobile {
      width: 100%;
      margin-top: 24px;
      margin-right: 0;
    }
  }
}

.error__block_robot {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-right: 30px;

  @include mobile {
    margin: 0;
  }
}

.error__block_logo {
  margin-bottom: 20px;
  max-width: 600px;
  width: 100%;

  @include mobile {
    max-width: 100%;
  }
}

.error__block_details {
  @include mobile {
    width: 100%;
  }
}
</style>
